<div class="user-dropdown-container">
  <!-- Botão do usuário -->
  <button class="user-trigger" (click)="toggleDropdown($event)">
    <div class="user-avatar-small">
      <mat-icon>person</mat-icon>
    </div>
    <span class="user-name-text">{{ userName() }}</span>
    <mat-icon class="dropdown-arrow">
      {{ panelOpenState() ? 'expand_less' : 'expand_more' }}
    </mat-icon>
  </button>

  <!-- Dropdown -->
  <div *ngIf="panelOpenState()" class="user-dropdown">
    <!-- Header do dropdown -->
    <div class="dropdown-header">
      <div class="dropdown-avatar">
        <mat-icon>person</mat-icon>
      </div>
      <div class="dropdown-user-info">
        <span class="dropdown-user-name">{{ userName() }}</span>
        <span class="dropdown-user-email">{{ userProfile?.email || '' }}</span>
      </div>
    </div>

    <div class="dropdown-divider"></div>

    <!-- Menu items -->
    <div class="dropdown-menu">
      <button class="dropdown-item" (click)="navigateToPage()">
        <mat-icon>settings</mat-icon>
        <span>{{ 'header.profile' | translate }}</span>
      </button>

      <button class="dropdown-item" (click)="toggleIdioma($event)">
        <mat-icon>language</mat-icon>
        <span>{{ 'header.language' | translate }}</span>
        <mat-icon class="item-arrow">
          {{ idiomaAberto ? 'expand_less' : 'expand_more' }}
        </mat-icon>
      </button>

      <!-- Submenu de idiomas -->
      <div *ngIf="idiomaAberto" class="language-submenu">
        <app-button-country (languageChanged)="onLanguageChanged($event)"></app-button-country>
      </div>
    </div>

    <div class="dropdown-divider"></div>

    <!-- Logout -->
    <div class="dropdown-footer">
      <button class="dropdown-item logout-item" (click)="onLogout()">
        <mat-icon>logout</mat-icon>
        <span>{{ 'header.logout' | translate }}</span>
      </button>
    </div>
  </div>
</div>
